/**
 * Site-wide Elementor behavior, bundled into medi-elementor.js.
 */

export function initElementor() {
  if (document.body.classList.contains('elementor-editor-active')) {
    return;
  }
  initScrollers();
}

// Adds previous and next buttons to every .md-scroller row, shown only when the row overflows.
const ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg>';

function initScrollers() {
  document.querySelectorAll('.md-scroller').forEach(initScroller);
}

function initScroller(track) {
  const wrap = document.createElement('div');
  wrap.className = 'md-scroller-wrap';
  track.parentNode.insertBefore(wrap, track);
  wrap.appendChild(track);

  const prev = makeButton('prev', 'Scroll left');
  const next = makeButton('next', 'Scroll right');
  prev.querySelector('svg').style.transform = 'scaleX(-1)';
  wrap.append(prev, next);

  const step = () => (track.firstElementChild ? track.firstElementChild.offsetWidth : track.clientWidth * 0.8);
  prev.addEventListener('click', () => track.scrollBy({ left: -step() }));
  next.addEventListener('click', () => track.scrollBy({ left: step() }));

  // A 1px tolerance absorbs subpixel rounding at either end.
  const update = () => {
    prev.hidden = track.scrollLeft <= 1;
    next.hidden = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
  };
  track.addEventListener('scroll', update, { passive: true });
  new ResizeObserver(update).observe(track);
  update();
}

function makeButton(direction, label) {
  const button = document.createElement('button');
  button.type = 'button';
  button.className = `md-scroller-button md-scroller-button--${direction}`;
  button.setAttribute('aria-label', label);
  button.innerHTML = ICON;
  return button;
}
